<app-content-header
  [historyBack]="false"
  [hideBackButton]="true"
  [headline]="'availability_downgrade_premium_confirm_headline' | i18next">
</app-content-header>

<app-icon-card>
  <p class="mb-5" [innerHTML]="'availability_downgrade_premium_confirm_offer_text' | i18next: {applianceName: displayName}"></p>

  <app-warning-confirm-box 
    [hideCancelBtn]="true"
    [confirmHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
    [confirmDetailsHeadline]="'availability_downgrade_premium_confirm_headline' | i18next"
    [confirmDetailsText]="'availability_downgrade_premium_confirm_text' | i18next"
    (confirm)="onConfirm()"
    [hideConfirmBtn]="true" 
    [hideHeader]="true">
  </app-warning-confirm-box>

  <div class="d-flex flex-column justify-content-end mt-5 mb-3">
    <app-pascom-checkbox class="align-self-end" inputId="accept"
      [text]="'availability_downgrade_premium_confirm_offer_accept_term'  | i18next"
      (acceptChanged)="onAccept($event)">
    </app-pascom-checkbox>

    <button class="btn btn-outline-primary align-self-end" type="button" (click)="onConfirm()" [disabled]="!accept">
      {{ 'availability_downgrade_premium_confirm_btn' | i18next }}
    </button>
  </div>
</app-icon-card>